import React, { useContext, useState, useEffect } from 'react';
import { GMCContext } from '../../GMCContext';
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import axios from "axios";
import Swal from "sweetalert2";


export default function TeamWithdrawal() {
    const { togel, setTogel, toastError, isSidebarEnabled, setIsSidebarEnabled, formatDateTime, setToken } = useContext(GMCContext);
    const statedata = JSON.parse(localStorage.getItem('mark#0143'))
    const [txUserId, setTxUserId] = useState("");

    const [loadingBalance, setLoadingBalance] = useState(false);
    const [isUserFound, setIsUserFound] = useState(false);


    const [reportType, setReportType] = useState(""); // user | team
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [reportLoading, setReportLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [reportDataExcel, setReportDataExcel] = useState([]);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pagination, setPagination] = useState({ total: 0, page: 1, pageSize: 10, totalPages: 1 });
    const [downloadLoading, setDownloadLoading] = useState(false);

    const fetchReportPage = async (p, ps) => {
        const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
            method: "admin",
            submethod: "getreport",
            username: txUserId,
            fromDate,
            toDate,
            type: reportType,
            page: Number(p),
            pageSize: Number(ps),
            key: process.env.REACT_APP_KEY
        });

        if (Array.isArray(res.data)) {
            return { rows: res.data, pagination: { total: res.data.length, page: 1, pageSize: res.data.length, totalPages: 1 } };
        }

        if (res.data?.resCode === 200) {
            return { rows: res.data?.data || [], pagination: res.data?.pagination || {} };
        }

        throw new Error(res.data?.message || "No data found");
    };

    const downloadReportExcel = async () => {
        if (!reportType || !fromDate || !toDate) {
            Swal.fire("Error", "Select type and dates first", "error");
            return;
        }

        try {
            setDownloadLoading(true);

            // Download ALL rows (not current page)
            const ALL_PAGE_SIZE = 1000;
            const first = await fetchReportPage(1, ALL_PAGE_SIZE);
            let allRows = [...(first.rows || [])];

            const totalPages = Number(first.pagination?.totalPages || 1);
            for (let p = 2; p <= totalPages; p += 1) {
                const next = await fetchReportPage(p, ALL_PAGE_SIZE);
                allRows = allRows.concat(next.rows || []);
            }

            if (!Array.isArray(allRows) || allRows.length === 0) {
                Swal.fire("Error", "No report data to download", "error");
                return;
            }

            // CSV opens in Excel without the "format and extension don't match" warning.
            const csvEscape = (val) => {
                const s = String(val ?? "");
                const needsQuotes = /[",\r\n]/.test(s);
                const escaped = s.replace(/"/g, '""');
                return needsQuotes ? `"${escaped}"` : escaped;
            };

            const metaLines = [
                ["Username", txUserId],
                ["Type", reportType],
                ["Date Range", `${fromDate} to ${toDate}`],
                [],
            ];

            const header = ["#", "Username", "Team", "Total Withdrawal", "Balance", "Total Staking", "Team Business"];
            const rows = allRows.map((row, idx) => ([
                idx + 1,
                row?.username ?? "",
                row?.team ?? "",
                Number(row?.totalWithdrawal || 0),
                Number((row?.balance).toFixed(2) || 0),
                Number(row?.totalStaking || 0),
                Number(row?.team_business || 0),
            ]));

            const csv = [
                ...metaLines,
                header,
                ...rows,
            ]
                .map((r) => r.map(csvEscape).join(","))
                .join("\r\n");

            // Add UTF-8 BOM for better Excel Unicode support
            const blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `report_${txUserId}_${reportType}_${fromDate}_to_${toDate}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e) {
            Swal.fire("Error", e?.message || "Failed to download", "error");
        } finally {
            setDownloadLoading(false);
        }
        return;
    };

    // (old download code removed)

    /*
    const downloadReportExcel = () => {
        ...
    };
    */

    const fetchBalance = async () => {
        if (!txUserId) {
            Swal.fire("Error", "Enter User ID", "error");
            return;
        }

        try {
            setLoadingBalance(true);
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "profile",
                key: process.env.REACT_APP_KEY,
                username: txUserId,
            });

            if (res.data?.resCode === 200) {
                setIsUserFound(true);
            } else {
                Swal.fire("Error", res.data?.error || res.data?.message || "User not found", "error");
                setIsUserFound(false);
            }
        } catch {
            Swal.fire("Error", "Server error", "error");
        } finally {
            setLoadingBalance(false);
        }
    };

    useEffect(() => {
        if (!txUserId || txUserId.trim() === "") {
            setIsUserFound(false);
        }
    }, [txUserId]);

    const handleGetReport = async (nextPage = page, nextPageSize = pageSize) => {
        if (!isUserFound) {
            Swal.fire("Error", "Verify user first", "error");
            return;
        }
        if (!fromDate || !toDate || !reportType) {
            Swal.fire("Error", "Select type and dates", "error");
            return;
        }

        try {
            setReportLoading(true);

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "admin",
                submethod: "getreport",
                username: txUserId,
                fromDate,
                toDate,
                type: reportType, // ✅ user OR team
                page: Number(nextPage),
                pageSize: Number(nextPageSize),
                key: process.env.REACT_APP_KEY
            });

            // Supports both:
            // 1) new paginated response { resCode, data, pagination }
            // 2) old response: array of rows
            if (Array.isArray(res.data)) {
                setReportData(res.data);
                setPagination({ total: res.data.length, page: 1, pageSize: res.data.length, totalPages: 1 });
                setPage(1);
                setPageSize(res.data.length);
            } else if (res.data?.resCode === 200) {
                setReportData(res.data?.data || []);
                setReportDataExcel(res.data?.summary || []);
                const p = res.data?.pagination || {};
                setPagination({
                    total: Number(p.total || 0),
                    page: Number(p.page || nextPage),
                    pageSize: Number(p.pageSize || nextPageSize),
                    totalPages: Number(p.totalPages || 1),
                });
                setPage(Number(p.page || nextPage));
                setPageSize(Number(p.pageSize || nextPageSize));
            } else {
                Swal.fire("Error", res.data?.message || "No data found", "error");
            }

        } catch (err) {
            Swal.fire("Error", "Server error", "error");
        } finally {
            setReportLoading(false);
        }
    };

    return (
        <>
            <Header />
            <Sidebar />

            <div className="buy-package-container">
                <h2 className="buy-title">User Report</h2>

                <div className="structure-content">

                    <div className="main-structure-flow">
                        <div className="glass-card search-card">
                            <div className="input-field-wrapper">
                                <i className="ri-user-search-line prefix-icon"></i>
                                <input
                                    type="text"
                                    placeholder="Enter Username"
                                    value={txUserId}
                                    onChange={(e) => setTxUserId(e.target.value)}
                                />
                                <button className="search-btn" onClick={fetchBalance} disabled={loadingBalance}>
                                    {loadingBalance ? <i className="ri-loader-4-line spin"></i> : "Find User"}
                                </button>
                            </div>
                        </div>

                        {isUserFound && (
                            <div className="glass-card form-card animate-slide-up">
                                <div className="form-header">
                                    <h4>Withdrawal / Staking Report</h4>
                                    <span className="badge">Verified: {txUserId}</span>
                                </div>

                                <div className="type-selection-grid">
                                    <label className={`selectable-card ${reportType === "user" ? "active" : ""}`}>
                                        <input
                                            type="radio"
                                            name="reportType"
                                            value="user"
                                            checked={reportType === "user"}
                                            onChange={(e) => setReportType(e.target.value)}
                                        />
                                        <div className="card-content">
                                            <i className="ri-user-3-line"></i>
                                            <span>User</span>
                                            <small>Only this username</small>
                                        </div>
                                    </label>

                                    <label className={`selectable-card ${reportType === "team" ? "active" : ""}`}>
                                        <input
                                            type="radio"
                                            name="reportType"
                                            value="team"
                                            checked={reportType === "team"}
                                            onChange={(e) => setReportType(e.target.value)}
                                        />
                                        <div className="card-content">
                                            <i className="ri-group-line"></i>
                                            <span>Team</span>
                                            <small>This user + level users</small>
                                        </div>
                                    </label>
                                </div>

                                <div className="report-controls">
                                    <div className="date-grid">
                                        <div className="date-field">
                                            <label>From Date</label>
                                            <input
                                                type="date"
                                                value={fromDate}
                                                onChange={(e) => setFromDate(e.target.value)}
                                                max={toDate || undefined}
                                                required
                                            />
                                        </div>
                                        <div className="date-field">
                                            <label>To Date</label>
                                            <input
                                                type="date"
                                                value={toDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                                min={fromDate || undefined}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="action-footer">
                                        <button
                                            className="primary-btn"
                                            onClick={() => {
                                                setPage(1);
                                                handleGetReport(1, pageSize);
                                            }}
                                            disabled={reportLoading}
                                        >
                                            {reportLoading ? "Finding..." : "Find"}
                                        </button>
                                        <button
                                            className="secondary-btn"
                                            onClick={downloadReportExcel}
                                            disabled={reportLoading || downloadLoading}
                                        >
                                            {downloadLoading ? "Preparing..." : "Download Excel"}
                                        </button>
                                        <button
                                            className="secondary-btn"
                                            onClick={() => {
                                                setReportType("");
                                                setFromDate("");
                                                setToDate("");
                                                setReportData([]);
                                            }}
                                            disabled={reportLoading}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>

                                <div className="report-results">
                                    <div className="report-results-header">
                                        <h5>Results</h5>
                                        <span className="muted">
                                            {Array.isArray(reportData) ? `${reportData.length} rows` : "0 rows"}
                                        </span>
                                    </div>

                                    <div className="table-wrap">
                                        <table className="report-table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">#</th>
                                                    <th className="text-center">Username</th>
                                                    <th className='text-center'>Team</th>
                                                    <th className="text-center">Total Withdrawal</th>
                                                    <th className='text-center'>Balance</th>
                                                    <th className="text-center">Total Staking</th>
                                                    <th className="text-center">Team Business</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(reportData) && reportData.length > 0 ? (
                                                    reportData.map((row, idx) => (
                                                        <tr key={`${row.username || "row"}-${idx}`}>
                                                            <td className="text-center">{idx + 1}</td>
                                                            <td className="mono">{row.username}</td>
                                                            <td className="text-center">{row.team}</td>
                                                            <td className="text-center">${Number(row.totalWithdrawal || 0).toLocaleString()}</td>
                                                            <td className='text-center'>${Number(row.balance || 0).toFixed(2)}</td>
                                                            <td className="text-center">${Number(row.totalStaking || 0).toLocaleString()}</td>
                                                            <td className="text-center">${Number(row.team_business || 0).toLocaleString()}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5} className="empty">
                                                            No data
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="pagination-bar">
                                        <div className="page-size">
                                            <span className="muted">Rows</span>
                                            <select
                                                value={pageSize}
                                                onChange={(e) => {
                                                    const next = Number(e.target.value);
                                                    setPageSize(next);
                                                    setPage(1);
                                                    handleGetReport(1, next);
                                                }}
                                                disabled={reportLoading}
                                            >
                                                {[10, 20, 50, 100].map((n) => (
                                                    <option key={n} value={n}>{n}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="page-controls">
                                            <button
                                                type="button"
                                                className="pager-btn"
                                                onClick={() => handleGetReport(Math.max(1, page - 1), pageSize)}
                                                disabled={reportLoading || page <= 1}
                                            >
                                                Prev
                                            </button>
                                            <span className="page-info">
                                                Page <b>{pagination?.page || page}</b> / <b>{pagination?.totalPages || 1}</b>
                                                <span className="muted" style={{ marginLeft: 10 }}>
                                                    ({pagination?.total || 0} total)
                                                </span>
                                            </span>
                                            <button
                                                type="button"
                                                className="pager-btn"
                                                onClick={() => handleGetReport(Math.min((pagination?.totalPages || 1), page + 1), pageSize)}
                                                disabled={reportLoading || page >= (pagination?.totalPages || 1)}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                </div>
            </div>

            <style>
                {`
                .buy-package-container {
                    max-width: 800px;
                    margin: 80px auto 40px;
                    padding: 20px;
                    font-family: 'Inter', system-ui, -apple-system, sans-serif;
                }

                .buy-title {
                    font-size: clamp(24px, 5vw, 32px);
                    font-weight: 800;
                    background: linear-gradient(135deg, #405189, #1a2a6c);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-bottom: 40px;
                    text-align: center;
                    letter-spacing: -1px;
                }

                .glass-card {
                    background: rgba(255, 255, 255, 0.98);
                    backdrop-filter: blur(12px);
                    border: 1px solid rgba(226, 232, 240, 0.8);
                    border-radius: 28px;
                    padding: clamp(20px, 4vw, 40px);
                    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.03), 0 5px 15px rgba(64, 81, 137, 0.05);
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .auth-card {
                    text-align: center;
                    max-width: 480px;
                    margin: 0 auto;
                }

                .form-icon {
                    font-size: 56px;
                    background: linear-gradient(135deg, #405189, #2b3a67);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-bottom: 24px;
                }

                .auth-card h3 {
                    font-size: 24px;
                    font-weight: 800;
                    color: #1e293b;
                    margin-bottom: 12px;
                }

                .auth-card p {
                    color: #64748b;
                    font-size: 15px;
                    line-height: 1.7;
                    margin-bottom: 30px;
                }

                .input-field-wrapper {
                    position: relative;
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;
                    background: #f8fafc;
                    border: 2px solid #f1f5f9;
                    border-radius: 18px;
                    padding: 6px 6px 6px 20px;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .input-field-wrapper:focus-within {
                    border-color: #405189;
                    background: #fff;
                    box-shadow: 0 10px 25px rgba(64, 81, 137, 0.08);
                    transform: translateY(-2px);
                }

                .input-field-wrapper input {
                    border: none;
                    background: transparent;
                    padding: 14px 12px;
                    width: 100%;
                    font-size: 16px;
                    color: #1e293b;
                    font-weight: 500;
                    outline: none;
                }

                .prefix-icon {
                    font-size: 20px;
                    color: #94a3b8;
                }

                .primary-btn {
                    background: linear-gradient(135deg, #405189, #2b3a67);
                    color: white;
                    border: none;
                    padding: 16px 32px;
                    border-radius: 18px;
                    font-weight: 700;
                    font-size: 16px;
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                }

                .primary-btn.full { width: 100%; }

                .primary-btn:hover:not(:disabled) {
                    transform: translateY(-3px);
                    box-shadow: 0 12px 24px rgba(64, 81, 137, 0.25);
                }

                .primary-btn:active {
                    transform: translateY(-1px);
                }

                .secondary-btn {
                    background: #f1f5f9;
                    color: #475569;
                    border: none;
                    padding: 16px 32px;
                    border-radius: 18px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .secondary-btn:hover {
                    background: #e2e8f0;
                    color: #1e293b;
                }

                .search-btn {
                    background: #405189;
                    color: white;
                    border: none;
                    padding: 12px 24px;
                    border-radius: 14px;
                    font-weight: 700;
                    font-size: 14px;
                    cursor: pointer;
                    white-space: nowrap;
                }

                .search-card { margin-bottom: 30px; }

                .report-controls{
                    margin-top: 10px;
                }

                .date-grid{
                    display:grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap:16px;
                    margin-bottom: 10px;
                }

                .date-field label{
                    display:block;
                    font-weight:700;
                    color:#334155;
                    margin-bottom:10px;
                    font-size:15px;
                    padding-left:4px;
                }

                .date-field input{
                    width:100%;
                    padding:14px 16px;
                    border-radius:18px;
                    border:2px solid #f1f5f9;
                    background:#f8fafc;
                    outline:none;
                    font-weight:700;
                    color:#1e293b;
                    transition: all .25s ease;
                }

                .date-field input:focus{
                    border-color:#405189;
                    background:#fff;
                    box-shadow: 0 10px 25px rgba(64, 81, 137, 0.08);
                    transform: translateY(-1px);
                }

                .report-results{
                    margin-top: 26px;
                    border-top: 2px solid #f8fafc;
                    padding-top: 18px;
                }

                .report-results-header{
                    display:flex;
                    align-items: baseline;
                    justify-content: space-between;
                    margin-bottom: 10px;
                }

                .report-results-header h5{
                    margin:0;
                    font-size:16px;
                    font-weight:900;
                    color:#1e293b;
                }

                .muted{
                    color:#64748b;
                    font-weight:700;
                    font-size:12px;
                }

                .table-wrap{
                    width:100%;
                    overflow:auto;
                    border:1px solid #f1f5f9;
                    border-radius:18px;
                    background:#fff;
                }

                .pagination-bar{
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    gap:12px;
                    margin-top:14px;
                    flex-wrap:wrap;
                }

                .page-size{
                    display:flex;
                    align-items:center;
                    gap:10px;
                }

                .page-size select{
                    padding:10px 12px;
                    border-radius:14px;
                    border:2px solid #f1f5f9;
                    background:#fff;
                    font-weight:800;
                    color:#1e293b;
                    outline:none;
                }

                .page-controls{
                    display:flex;
                    align-items:center;
                    gap:10px;
                }

                .pager-btn{
                    border:2px solid #f1f5f9;
                    background:#fff;
                    color:#334155;
                    padding:10px 14px;
                    border-radius:14px;
                    font-weight:900;
                    cursor:pointer;
                    transition: all .2s ease;
                }

                .pager-btn:disabled{
                    opacity:.5;
                    cursor:not-allowed;
                }

                .pager-btn:hover:not(:disabled){
                    border-color:#405189;
                    color:#405189;
                    transform: translateY(-1px);
                }

                .page-info{
                    font-weight:800;
                    color:#1e293b;
                    font-size:13px;
                    white-space:nowrap;
                }

                .report-table{
                    width:100%;
                    border-collapse:separate;
                    border-spacing:0;
                    min-width: 720px;
                }

                .report-table thead th{
                    position:sticky;
                    top:0;
                    background:#f8fafc;
                    color:#334155;
                    font-weight:900;
                    font-size:13px;
                    padding:14px 14px;
                    border-bottom:1px solid #eef2f7;
                    white-space:nowrap;
                }

                .report-table tbody td{
                    padding:14px 14px;
                    border-bottom:1px solid #f1f5f9;
                    font-weight:700;
                    color:#0f172a;
                    font-size:14px;
                    white-space:nowrap;
                }

                .report-table tbody tr:hover td{
                    background: rgba(64, 81, 137, 0.03);
                }

                .text-end{ text-align:right; }
                .mono{ font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace; }
                .empty{ text-align:center; color:#64748b; font-weight:700; }

                .form-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 30px;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #f8fafc;
                }

                .form-header h4 {
                    margin: 0;
                    color: #1e293b;
                    font-size: 20px;
                    font-weight: 800;
                }

                .badge {
                    background: #f0f4ff;
                    color: #405189;
                    padding: 8px 16px;
                    border-radius: 24px;
                    font-size: 13px;
                    font-weight: 700;
                    border: 1px solid rgba(64, 81, 137, 0.1);
                }

                .type-selection-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                    gap: 16px;
                    margin-bottom: 35px;
                }

                .selectable-card {
                    cursor: pointer;
                    position: relative;
                }

                .selectable-card input {
                    position: absolute;
                    opacity: 0;
                }

                .card-content {
                    background: #fff;
                    border: 2px solid #f1f5f9;
                    border-radius: 22px;
                    padding: 24px;
                    text-align: center;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                }

                .card-content i {
                    font-size: 32px;
                    color: #94a3b8;
                    transition: color 0.3s ease;
                }

                .card-content span {
                    font-weight: 800;
                    color: #334155;
                    font-size: 17px;
                }

                .card-content small {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 500;
                }

                .selectable-card:hover .card-content {
                    border-color: #e2e8f0;
                    transform: translateY(-4px);
                }

                .selectable-card.active .card-content {
                    border-color: #405189;
                    background: rgba(64, 81, 137, 0.03);
                    box-shadow: 0 10px 20px rgba(64, 81, 137, 0.06);
                }

                .selectable-card.active .card-content i {
                    color: #405189;
                    transform: scale(1.1);
                }

                .selectable-card.active .card-content span {
                    color: #405189;
                }

                .parameters-body { margin-top: 35px; }

                .input-group-field label {
                    display: block;
                    font-weight: 700;
                    color: #334155;
                    margin-bottom: 12px;
                    font-size: 15px;
                    padding-left: 4px;
                }

                .limit-hint {
                    color: #94a3b8;
                    font-weight: 500;
                    font-size: 13px;
                    margin-left: 6px;
                }

                .number-input-wrapper {
                    position: relative;
                    background: #f8fafc;
                    border-radius: 18px;
                    overflow: hidden;
                    border: 2px solid #f1f5f9;
                    transition: all 0.3s ease;
                }

                .number-input-wrapper:focus-within {
                    border-color: #405189;
                    background: #fff;
                }

                .number-input-wrapper input {
                    padding: 16px 20px;
                    width: 100%;
                    border: none;
                    background: transparent;
                    font-weight: 800;
                    font-size: 22px;
                    color: #1e293b;
                    outline: none;
                }

                .limit-track {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 4px;
                    background: linear-gradient(to right, #405189, #2b3a67);
                    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .action-footer {
                    display: flex;
                    gap: 15px;
                    margin-top: 40px;
                }

                @media (max-width: 640px) {
                    .buy-package-container {
                        margin-top: 60px;
                        padding: 15px;
                    }

                    .glass-card {
                        padding: 24px 20px;
                        border-radius: 22px;
                    }

                    .input-field-wrapper {
                        padding: 2px 2px 2px 14px;
                        border-radius: 14px;
                    }

                    .search-btn {
                        padding: 10px 16px;
                        font-size: 13px;
                    }

                    .type-selection-grid {
                        grid-template-columns: 1fr;
                        gap: 12px;
                    }

                    .card-content {
                        flex-direction: row;
                        padding: 16px;
                        gap: 16px;
                        text-align: left;
                    }

                    .card-content i { font-size: 24px; }

                    .action-footer {
                        flex-direction: column;
                    }

                    .primary-btn, .secondary-btn {
                        width: 100%;
                        font-size: 15px;
                    }

                    .form-header {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 12px;
                    }

                    .date-grid{
                        grid-template-columns: 1fr;
                    }
                }

                .loader {
                    width: 20px;
                    height: 20px;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    border-top-color: #fff;
                    animation: spin 0.8s linear infinite;
                }

                .processing-indicator {
                    margin-top: 25px;
                    background: #f8fafc;
                    padding: 20px;
                    border-radius: 20px;
                    border: 1px solid #f1f5f9;
                }

                .progress-track {
                    height: 6px;
                    background: #e2e8f0;
                    border-radius: 10px;
                    overflow: hidden;
                    position: relative;
                }

                .progress-fill.indeterminate {
                    width: 40%;
                    height: 100%;
                    background: linear-gradient(90deg, #405189, #2b3a67);
                    position: absolute;
                    left: -40%;
                    animation: indeterminateProgress 1.5s infinite ease-in-out;
                    border-radius: 10px;
                }

                @keyframes indeterminateProgress {
                    0% { left: -40%; }
                    100% { left: 140%; }
                }

                .loading-status {
                    margin-top: 12px;
                    font-size: 13px;
                    font-weight: 700;
                    color: #405189;
                    text-align: center;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                }

                .error-alert {
                    color: #dc2626;
                    background: #fef2f2;
                    padding: 14px;
                    border-radius: 14px;
                    margin-bottom: 20px;
                    font-size: 14px;
                    font-weight: 600;
                    border: 1px solid rgba(220, 38, 38, 0.1);
                    text-align: center;
                    animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;
                }

                @keyframes shake {
                    10%, 90% { transform: translate3d(-1px, 0, 0); }
                    20%, 80% { transform: translate3d(2px, 0, 0); }
                    30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
                    40%, 60% { transform: translate3d(4px, 0, 0); }
                }

                .animate-slide-up { animation: slideUp 0.6s cubic-bezier(0.23, 1, 0.32, 1) forwards; }
                .animate-fade-in { animation: fadeIn 0.5s ease forwards; }

                @keyframes slideUp {
                    from { transform: translateY(30px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                .spin { animation: spin 1s linear infinite; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                `}
            </style>
            <Footer />
        </>
    );
}
